import { Box, Tooltip, tooltipClasses, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CompairLogoImg from '../../assets/compair-logo-transparent.png';
import PropTypes from 'prop-types';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        margin: 0 auto;
        width: 150px;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100],
  },
}));

function Logo({ size = 'md' }) {
  const { t } = useTranslation();

  return (
    <TooltipWrapper title={t('Compair Dashboard')} arrow>
      <LogoWrapper to="/" size={size}>
        <Box
          component="img"
          alt="Compair logo"
          src={CompairLogoImg}
          width="100%"
        />
      </LogoWrapper>
    </TooltipWrapper>
  );
}

Logo.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default Logo;
